const isAdmin = (role) => {
	if (!role) return false;
	const roles = role.split(',') || [];
	const included = roles?.includes('admin');
	return included;
};

const isAssistant = (role) => {
	if (!role) return false;
	const roles = role.split(',') || [];
	const included = roles?.includes('assistant');
	return included;
};

export { isAdmin, isAssistant };
